import * as React from "react";

import "./variations-ui.scss";

import {cx} from "emotion";

export const VariationSelectionUi = ({fields}:{
    fields: Array<{
        id: string,
        name: string,
        resource: null | {
            label: string,
            url: string,
        },
        options: Array<{
            id: string,
            label: string,
            isOutOfStock: boolean,
            isSelected: boolean,
            select: () => void,
        }>,
    }>,
}) => (
    <div className="variation-selection-3739c8">
        {fields.map((field) => (
            <section key={field.id} className="field" xd-qa-type="card" xd-qa-name={field.name}>
                <header>
                    <span className="label" xd-qa-type="label" xd-qa-name="FieldName">{field.name}</span>
                    {field.resource && (
                        <a
                            className="resource-link"
                            target="_blank"
                            href={field.resource.url}
                            xd-qa-type="link"
                            xd-qa-name="FieldResourceLink"
                        >{field.resource.label}</a>
                    )}
                </header>
                <div className="options">
                    {field.options.map(option => (
                        <button
                            key={option.id}
                            className={cx("option", {'out-of-stock': option.isOutOfStock, active: option.isSelected})}
                            onClick={option.select}
                            aria-label="Combination out of stock. Click to see available options for this selection."
                            xd-qa-type="button"
                            xd-qa-name={option.label}
                        >{option.label}</button>
                    ))}
                </div>
            </section>
        ))}
    </div>
);

